var React = require('react');

function IcAwsAppstream (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M1.43,0.227v1.294l13.352,13.352h3.031L5.31,2.37h32.547v32.547L24.896,21.956v3.031l13.81,13.81L40,38.798\n\t\tV0.226H1.43L1.43,0.227L1.43,0.227z M0.005,18.315l21.459,21.459l1.289-0.003V17.018H0L0.005,18.315z M20.61,19.161v16.73\n\t\tL3.88,19.161H20.61z"})));
}

IcAwsAppstream.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsAppstream;

IcAwsAppstream.default = IcAwsAppstream;
